"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("./helpers");
const dom_focus_lock_1 = __importDefault(require("./libs/dom-focus-lock"));
/**
 * Инициализирует переключение полноэкранного элемента с управлением клавишей Esc.
 *
 * @param {elementTogglerOptions} options
 */
function initElementToggler({ $element, toggleTrigger, openTrigger, closeTrigger, onBeforeOpen, onOpen, onOpenComplete, onBeforeClose, onClose, onAfterClose, onCloseComplete, animationDuration, displayNoneWhenInvisible = true, }) {
    let isOpen = false;
    let $opener = null;
    // Переменные для хранения идентификаторов таймаутов
    let openCompleteTimeoutId = null;
    let closeCompleteTimeoutId = null;
    const escHandler = (e) => {
        if (e.key === 'Escape') {
            close();
        }
    };
    const open = (event) => __awaiter(this, void 0, void 0, function* () {
        if (isOpen)
            return;
        if (displayNoneWhenInvisible) {
            $element.removeAttribute('style');
            let delay = ms => new Promise(resolve => setTimeout(resolve, ms));
            yield delay(1);
        }
        if (closeCompleteTimeoutId !== null) {
            clearTimeout(closeCompleteTimeoutId);
            closeCompleteTimeoutId = null;
        }
        if (event && event.currentTarget && event.currentTarget instanceof HTMLElement) {
            $opener = event.currentTarget;
        }
        onBeforeOpen && onBeforeOpen();
        isOpen = true;
        $element.setAttribute('data-opened', '');
        $element.removeAttribute('inert');
        (0, helpers_1.blockScrollBody)();
        dom_focus_lock_1.default.on($element);
        onOpen && onOpen();
        window.addEventListener('keydown', escHandler);
        if (onOpenComplete && animationDuration) {
            openCompleteTimeoutId = window.setTimeout(() => {
                onOpenComplete && onOpenComplete();
                openCompleteTimeoutId = null;
            }, animationDuration * 1000);
        }
    });
    const close = () => {
        if (!isOpen)
            return;
        if (openCompleteTimeoutId !== null) {
            clearTimeout(openCompleteTimeoutId);
            openCompleteTimeoutId = null;
        }
        onBeforeClose && onBeforeClose();
        isOpen = false;
        $element.removeAttribute('data-opened');
        $element.setAttribute('inert', '');
        (0, helpers_1.unblockScrollBody)();
        dom_focus_lock_1.default.off($element);
        onClose && onClose();
        window.removeEventListener('keydown', escHandler);
        onAfterClose && onAfterClose();
        if (onCloseComplete && animationDuration) {
            closeCompleteTimeoutId = window.setTimeout(() => {
                onCloseComplete && onCloseComplete();
                closeCompleteTimeoutId = null;
                if (displayNoneWhenInvisible) {
                    $element.style.display = 'none';
                }
            }, animationDuration * 1000);
        }
        if ($opener) {
            $opener.focus();
            $opener = null;
        }
    };
    const toggle = (event) => {
        if (isOpen)
            close();
        else
            open(event);
    };
    if (toggleTrigger) {
        if ((0, helpers_1.isIterable)(toggleTrigger)) {
            Array.from(toggleTrigger).forEach($toggleTrigger => {
                $toggleTrigger.addEventListener('click', event => toggle(event));
            });
        }
        else {
            toggleTrigger.addEventListener('click', event => toggle(event));
        }
    }
    if (openTrigger) {
        if ((0, helpers_1.isIterable)(openTrigger)) {
            Array.from(openTrigger).forEach($openTrigger => {
                $openTrigger.addEventListener('click', event => open(event));
            });
        }
        else {
            openTrigger.addEventListener('click', event => open(event));
        }
    }
    if (closeTrigger) {
        if ((0, helpers_1.isIterable)(closeTrigger)) {
            Array.from(closeTrigger).forEach($closeTrigger => {
                $closeTrigger.addEventListener('click', close);
            });
        }
        else {
            closeTrigger.addEventListener('click', close);
        }
    }
    return { close };
}
exports.default = initElementToggler;
